import { useEffect, useState } from "react";
import { api } from "@/lib/config";

let cached = null;
const subscribers = new Set();

export function useContent() {
  const [content, setContent] = useState(cached || {});

  useEffect(() => {
    const update = (c) => setContent(c);
    subscribers.add(update);
    if (!cached) {
      api.get("/content").then(({ data }) => {
        cached = data;
        subscribers.forEach((fn) => fn(data));
      }).catch(() => {});
    }
    return () => subscribers.delete(update);
  }, []);

  return content;
}

export async function refreshContent() {
  const { data } = await api.get("/content");
  cached = data;
  subscribers.forEach((fn) => fn(data));
  return data;
}

export const C = (content, key, fallback = "") => content[key] ?? fallback;
